/**
 * @function useHydrate
 * @description Used to initialize components, for when the window doesn't reload fully.
 * @param {function[]} - Array of function run loop through
 * @returns {useHydrate~hydrate} - the returned function
 * @returns {useHydrate~dehydrate} - the returned function again
 */
export default components => {
  let teardownFunctions = null

  return {
    /**
     * @memberof useHydrate
     * @description Runs all the passed functions. Any arguments passed will be passed on to the components
     * @param {*} ...args - n arguments that should be passed to the components
     */
    hydrate(...args) {
      // teardown any previously hydrated components
      this.dehydrate()

      setTimeout(() => {
        const componentsArray = [].concat(components)

        teardownFunctions = componentsArray
          .map(component => {
            if (typeof component !== 'function') {
              return
            }

            // Isolate each component: a throw in one must not abort the loop
            // and leave every later component un-hydrated (which previously
            // turned a single failure into a dead page).
            try {
              return [].concat(component(...args))
            } catch (error) {
              console.error('[hydrate] component failed to initialize:', error)
              return
            }
          })
          .flat(10)
          .filter(Boolean)
      })

      return args.length > 1 ? [args] : args[0]
    },

    /**
     * @memberof useHydrate
     * @description Runs any/all the returned functions returned from the `hydrate`
     */
    dehydrate() {
      teardownFunctions?.map(async teardown => {
        const value = await Promise.resolve(teardown)

        if (Array.isArray(value)) {
          value.forEach(v => {
            if (typeof v === 'function') {
              v()
            }
          })
        }

        if (typeof value === 'function') {
          value()
        }
      })
      teardownFunctions = null
    },
  }
}
